// extracted by mini-css-extract-plugin
module.exports = {"delete":"ClassList_delete__1uv6U"};